import { render, staticRenderFns } from "./request_detail.vue?vue&type=template&id=5c440f32&scoped=true&"
import script from "./request_detail.vue?vue&type=script&lang=js&"
export * from "./request_detail.vue?vue&type=script&lang=js&"
import style0 from "./request_detail.vue?vue&type=style&index=0&id=5c440f32&lang=less&scoped=true&"
import style1 from "./request_detail.vue?vue&type=style&index=1&id=5c440f32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c440f32",
  null
  
)

export default component.exports